import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { FormBuilder, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HeaderComponent } from './header.component';
import { PipesModule } from 'octali-lib-utils';
import { AccountPopoverComponentModule } from '../../user/account-popover/account-popover.module';
//import { AccountPopoverComponentModule } from '../user/account/account-popover/account-popover.module';
//import { SearchModalComponentModule } from '../search/search-modal/search-modal.module';

@NgModule({
  declarations: [
    HeaderComponent,  
  ],
  imports: [
    CommonModule,
    IonicModule,
    PipesModule,
    FormsModule,
    ReactiveFormsModule,
    AccountPopoverComponentModule
  ],
  providers: [
    FormBuilder
  ],
  exports: [
    HeaderComponent
  ],
  entryComponents: [],
})
export class HeaderComponentModule { }
